export default __webpack_public_path__ + "58a85a03570021cebb0d72e8a5f1bf7b.svg";